import { useNavigate, useSearchParams } from "react-router-dom"
import { memo, useEffect, useMemo } from "react"
import { useActions } from "../../../hooks/useActions"
import { useTypedSelector } from "../../../hooks/useTypedSelector"
import { Flex, Space, Spin, Table, message } from "antd"
import useProjectDataColumns from "../hooks/UseProjectDataColumns"
import { TableProps } from "antd"
import { IProjectData } from "../types/projectData.types"
import AddAsin from "./AddAsin"
import { routePath } from "../../../router/types"
import useMaxRows from "../../../hooks/useMaxRows"

const MemoTable = memo<TableProps<IProjectData>>(Table)

const ProjectData: React.FC = () => {
  const [searchParams] = useSearchParams()
  const projectId = searchParams.get("projectId")

  const rowCount = useMaxRows({ rowHeight: 98, offset: 250 })

  const { getProjectData } = useActions()
  const { projectData, loading, error } = useTypedSelector((state) => state.projectData)
  const navigate = useNavigate()

  useEffect(() => {
    if (!projectId) {
      navigate(routePath.PROJECTS)
      return
    }

    getProjectData(projectId)
  }, [projectId])

  useEffect(() => {
    if (error) {
      message.error(error)
    }
  }, [error])

  // Hook must be called at the top level, not inside useMemo
  const columns = useProjectDataColumns(projectData)

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Flex vertical align="flex-start">
        <AddAsin />
      </Flex>
      <Flex justify="center" style={{ width: "100%" }}>
        {loading ? <Spin /> : null}
      </Flex>
      {!loading ? (
        <MemoTable
          dataSource={projectData}
          columns={columns}
          pagination={{
            pageSize: rowCount,
          }}
        />
      ) : null}
    </Space>
  )
}

export default ProjectData
